import Vue from 'vue'
export default {
    setPersonaLearingStatus (state, data) {
        state.personaLearingStatus = data;
    },
    setTabtype (state, data) {
        state.tabtype = data;
    },

}

